var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.footerClass,attrs:{"id":"footer"}},[_c('p',{staticClass:"description"},[_vm._v("©︎ 2020 Matsuo")])])}
var staticRenderFns = []

export { render, staticRenderFns }